<template>
	<v-container grid-list-md class="pa-0">
		<v-layout row wrap>
			<v-flex md12>
				<v-card flat color="transparent" class="pa-0 ma-0">
					<v-card-title primary-title>
						{{ $t("title.pending_reservations") }}
					</v-card-title>
					<v-card-text class="pa-0">
						<v-expansion-panels>
							<v-expansion-panel
								v-for="(reservation, index) in reservations"
								:key="index"
							>
								<v-expansion-panel-header v-slot="{ open }">
									<ReservationExpansionHeader
										:reservation="reservation"
										:open="open"
									></ReservationExpansionHeader>
								</v-expansion-panel-header>
								<v-expansion-panel-content
									class="grey lighten-4"
								>
									<v-container grid-list-xl>
										<v-layout row wrap>
											<v-flex xs12 md6>
												<v-card flat>
													<v-card-text>
														<ReservationDetail
															:reservation="
																reservation
															"
														></ReservationDetail>
													</v-card-text>
												</v-card>
											</v-flex>
											<v-flex xs12 md6>
												<v-card flat>
													<v-card-text
														class="py-3 px-2"
													>
														<ReservationCustomerDetail
															:reservation="
																reservation
															"
														></ReservationCustomerDetail>
													</v-card-text>
													<v-card-actions>
														<v-btn
															color="error"
															dark
															@click="
																deny(
																	reservation
																)
															"
															:loading="
																item.processing
															"
														>
															{{
																$t("label.deny")
															}}
														</v-btn>
														<v-btn
															color="primary"
															dark
															@click="
																confirmed(
																	reservation
																)
															"
															:loading="
																item.processing
															"
															>{{
																$t(
																	"label.confirmed"
																)
															}}
														</v-btn>
													</v-card-actions>
												</v-card>
											</v-flex>
										</v-layout>
									</v-container>
								</v-expansion-panel-content>
							</v-expansion-panel>
						</v-expansion-panels>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>
<script>
import ReservationExpansionHeader from "@Reservation/components/ReservationExpansionHeader.vue";
import ReservationDetail from "@Reservation/components/ReservationDetail.vue";
import ReservationCustomerDetail from "@Reservation/components/ReservationCustomerDetail.vue";
import TenantLayout from "@/layouts/tenant.vue";
import TenantReservationLayout from "@Reservation/layouts/reservation_layout.vue";
export default {
	layout: [TenantLayout, TenantReservationLayout],
	components: {
		ReservationExpansionHeader,
		ReservationDetail,
		ReservationCustomerDetail,
	},
	props: ["reservations"],
	data() {
		return {
			item: this.$inertia.form({}),
		};
	},
	methods: {
		confirmed(reservation) {
			this.$vloading.show();
			this.item.post(
				this.$route("tenant.reservations.mark_as_confirmed", {
					tenant: this.$page.props.tenant.id,
					reservation: reservation.uuid,
				})
			);
		},

		deny(reservation) {
			this.$vloading.show();
			this.item.post(
				this.$route("tenant.reservations.mark_as_denied", {
					tenant: this.$page.props.tenant.id,
					reservation: reservation.uuid,
				})
			);
		},
	},
};
</script>